import { createBrowserHistory } from 'history';

export const history = createBrowserHistory({
  basename: (process.env as { PUBLIC_URL?: string }).PUBLIC_URL,
  getUserConfirmation: (message, callback) => {
    callback(!!message);
  },
});
